import React from 'react';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import SetFinalValue from './SetEndValue';
import SetInitialValue from './SetInitialValue';

function SetPeriod() {
  return (
    <Wrapper.Default
      flexDirection="column"
      alignItens="start"
      width="32%"
      isActive>
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Valor entre:
      </span>
      <Wrapper.Default flexDirection="row" width="100%" isActive>
        <SetInitialValue />
        <span style={{ fontWeight: 700, padding: '0 0.5rem' }}>a</span>
        <SetFinalValue />
      </Wrapper.Default>
    </Wrapper.Default>
  );
}

export default SetPeriod;
